import { css } from '@/styled-system/css';

export const filterContainerStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  rowGap: 'tighter',
  columnGap: 'default',

  lgDown: {
    flexDirection: 'column',
  },

  md: {
    flexWrap: 'wrap',
  },
});
